<template>
    <div>
        <div class="row">
            <div id="logo-unimed">
                <v-img :src="require('../assets/imgs_unimed/logotipo.png')"/>
            </div>
        </div>
        <div class="deniedAccess">
            <h1>Oops! :( Erro 403</h1>
            <div class="description">
                <span>
                    Você não tem permissão para acessar esta página...
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="sass" scoped>
.deniedAccess
  padding: 18px 13px
  max-width: 480px
  width: 100%

  h1
    color: #ED1651
    text-align: left
    font-family: 'unimed_slabbold'
    font-weight: bold
    font-size: 60px

.description
  text-align: left
  font: Normal 30px/35px Trebuchet MS
  margin-top: 20px
  margin-bottom: 20px
  color: #60656C

ul
  list-style: none
  color: #2699FB
  text-decoration: none
  font: Normal 16px/19px Trebuchet MS
  line-height: 1.8em
  float: left
  margin-right: 25px

.links-uteis span
  float: left
  width: 100%
  font: Normal 18px/21px Trebuchet MS
  margin-bottom: 20px
  color: #60656C

.right-list
  margin-left: 80px

.row
  padding: 40px 25px
</style>
